import { Injectable } from '@angular/core';
import { SalesByProductsExportQuery, SalesByProductsExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SalesByProductsExportQuery)
@Wrapper(SalesByProductsExportQueryHandlerBase)
export class SalesByProductsExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
